var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThongBaoPhatHanhMau97685D93(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4374",
    "data-name": "Ellipse 4374",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(0 0)",
    fill: "#f5f8fb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 1.354,
    y1: 1.526,
    x2: 0.437,
    y2: 0.052,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6bd2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b7edfe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0.318,
    y1: 0.153,
    x2: 0.918,
    y2: 0.762,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00af2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#83d85c",
    stopOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ThongBaoPhatHanhMau",
    transform: "translate(-892 -293)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_53141",
    "data-name": "Group 53141",
    transform: "translate(11518 5867)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4372",
    "data-name": "Ellipse 4372",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(-10626 -5574)",
    fill: "#f5f9fc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_10",
    "data-name": "Mask Group 10",
    transform: "translate(-10626 -5574)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22902",
    "data-name": "Rectangle 22902",
    width: 44.726,
    height: 24.789,
    rx: 4,
    transform: "translate(18.346 32.969)",
    fill: "#007aff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53139",
    "data-name": "Group 53139",
    transform: "translate(10.51 20.218)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22825",
    "data-name": "Rectangle 22825",
    width: 58.981,
    height: 27.789,
    rx: 4,
    transform: "translate(-0.464 0)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22803",
    "data-name": "Rectangle 22803",
    width: 29.362,
    height: 3.901,
    rx: 1.95,
    transform: "translate(14.549 13.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22804",
    "data-name": "Rectangle 22804",
    width: 16.551,
    height: 4.169,
    rx: 2.085,
    transform: "translate(21.864 20.562)",
    fill: "#73d0f8",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53270",
    "data-name": "Group 53270",
    transform: "translate(25.672 2.782)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22802",
    "data-name": "Rectangle 22802",
    width: 9,
    height: 9,
    rx: 4.5,
    transform: "translate(-0.181)",
    fill: "#007aff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76042",
    "data-name": "Path 76042",
    d: "M25.294,7.247,26.946,8.9l2.7-2.7",
    transform: "translate(-22.794 -3.051)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Component_155_4",
    "data-name": "Component 155 \\u2013 4",
    transform: "translate(946 347)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4388",
    "data-name": "Ellipse 4388",
    cx: 13,
    cy: 13,
    r: 13,
    fill: "#72cc49",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76000",
    "data-name": "Path 76000",
    d: "M44.24,135.618,33.974,127.5l-6.035,9.1,7.895,7.243Z",
    transform: "translate(-19.736 -119.854)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_53206",
    "data-name": "Group 53206",
    transform: "translate(7.942 6.49)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_76001",
    "data-name": "Path 76001",
    d: "M31.2,121.576a1.073,1.073,0,0,0-1.073,1.073v.306h0a.083.083,0,0,1-.053.078,3.842,3.842,0,0,0-2.483,3.607v1.64a2.382,2.382,0,0,1-.255.953l-.644,1.082c-.032.054-.065.108-.1.163-.236.389-.489.805-.349,1.192.147.417.76.745,1.226.914a.345.345,0,0,0,.116.02h3.779c1.283,0,2.386,0,3.779.006a.33.33,0,0,0,.115-.019,2.043,2.043,0,0,0,1.2-.921c.15-.405-.12-.848-.357-1.236l-.072-.119-.638-1.076a2.441,2.441,0,0,1-.255-.96v-1.64a3.841,3.841,0,0,0-2.515-3.618.071.071,0,0,1-.046-.067h0v-.306a1.073,1.073,0,0,0-1.073-1.073Z",
    transform: "translate(-26.204 -121.576)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76002",
    "data-name": "Path 76002",
    d: "M36.385,154.709a.358.358,0,0,0-.358.358v.255a1.431,1.431,0,0,0,1.431,1.431h.408a1.431,1.431,0,0,0,1.431-1.431v-.255a.358.358,0,0,0-.358-.358Z",
    transform: "translate(-32.513 -142.857)",
    fill: "#fff",
    fillRule: "evenodd"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThongBaoPhatHanhMau97685D93);
export default __webpack_public_path__ + "static/media/ThongBaoPhatHanhMau.97685d93.b361316a49f516395c87276a0b64be5b.svg";
export { ForwardRef as ReactComponent };